import inboundOrderManagement from './inboundOrderManagement'
import outboundOrderManagement from './outboundOrderManagement'


// 仓储管理 定制逻辑处理
export default {
  ...inboundOrderManagement,
  ...outboundOrderManagement,
}
